<div class="card custom-box border-0 min-vh-100">
  <div class="row justify-content-center">
    <quill-view-html [content]="newsContent || ''" class="ql-align-center" theme="snow"></quill-view-html>
  </div>
</div>
